interface DistributorRef {
  id?: number | null;
}

interface AppUserRef {
  role?: string;
  distributor?: DistributorRef | null;
  permissions?: string[];
  can_escalate?: boolean;
}

export interface UserCapabilities {
  canFetchMarketingCampaign: boolean;
  canQueryEscalations: boolean;
}

const hasDistributor = (user: AppUserRef | null | undefined): boolean =>
  Boolean(user?.distributor?.id);

const hasEscalationManagementPermission = (user: AppUserRef | null | undefined): boolean =>
  Array.isArray(user?.permissions) && user.permissions.includes('escalation_management');

export const getUserCapabilities = (
  user: AppUserRef | null | undefined,
  isAuthenticated: boolean
): UserCapabilities => {
  const canFetchMarketingCampaign = Boolean(
    isAuthenticated &&
    user?.role === 'MobileUser' &&
    hasDistributor(user)
  );

  const canQueryEscalations = Boolean(
    isAuthenticated && (
      user?.role === 'SuperAdminUser' ||
      (
        user?.role === 'PlatformUser' &&
        hasDistributor(user) &&
        hasEscalationManagementPermission(user)
      ) ||
      (
        user?.role === 'MobileUser' &&
        user?.can_escalate === true
      )
    )
  );

  return {
    canFetchMarketingCampaign,
    canQueryEscalations,
  };
};
